import * as Immutable from 'immutable';

import { CompetitionImmutable } from '../../components/Competitions/CompetitionsTypes';
import { CHALLENGE_LEADERBOARD_NAME_PREFIX } from '../constants';

export const hasChallengeLeaderboard = (competitions: Immutable.List<CompetitionImmutable> | undefined | null): boolean => {
  if (!competitions || competitions.size === 0) {
    return false;
  }
  return competitions.some(competition => {
    const name = competition?.get('name');
    return typeof name === 'string' && name.startsWith(CHALLENGE_LEADERBOARD_NAME_PREFIX);
  });
};

export const shouldShowGoldDialog = (
  competitions: Immutable.List<CompetitionImmutable> | undefined | null,
  goldDialogShown: boolean | undefined
): boolean => {
  return !goldDialogShown && hasChallengeLeaderboard(competitions);
};
